import React, { useState, useEffect } from "react";
import { PMNDPModal } from "../components";
import { Tooltip, IconButton, Box } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import "../components/pmndp-enhanced.module.css";
import { pmndpAPI } from "../../../services/pmndp.api";
import AddBagsModal from "./AddBagsModal";

const BagsHistoryModal = ({ isOpen = true, onClose, patient }) => {
  const labels = {
    title: "Bags History",
    srNo: "Sr.No.",
    appointmentDate: "Appointment Date",
    batchNo: "CAPD Batch No.",
    expiryDate: "CAPD Batch Expiry Date",
    noOfBags: "No. of Bags",
    nextDueDate: "Next due Date",
    action: "Action",
    noData: "No record found!",
  };

  const [tableData, setTableData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedBag, setSelectedBag] = useState(null);

  const fetchHistory = async () => {
    try {
      setIsLoading(true);
      const resp = await pmndpAPI.getBagHistory(patient.id);
      const list = resp?.data;
      setTableData(Array.isArray(list) ? list : []);
    } catch (error) {
      console.error("Error fetching bag history:", error);
      setTableData([]);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (!isOpen || !patient?.id) return;
    fetchHistory();
  }, [isOpen, patient?.id]);

  const handleEdit = (item) => {
    setSelectedBag(item);
    setShowEditModal(true);
  };

  const handleEditSuccess = () => {
    fetchHistory();
  };

  return (
    <PMNDPModal
      isOpen={isOpen}
      onClose={onClose}
      title={
        <div className="modal-title-wrapper">
          <span>{labels.title}</span>
        </div>
      }
      size="large"
      icon="fa-history"
      hideFooter
    >
      <div className="table-responsive">
        <table className="pmndp-table">
          {/* ✅ HEADER */}
          <thead>
            <tr>
              <th>{labels.srNo}</th>
              <th>{labels.appointmentDate}</th>
              <th>{labels.batchNo}</th>
              <th>{labels.expiryDate}</th>
              <th>{labels.noOfBags}</th>
              <th>{labels.nextDueDate}</th>
              <th>{labels.action}</th>
            </tr>
          </thead>

          {/* ✅ BODY */}
          <tbody>
            {isLoading ? (
              <tr>
                <td colSpan="7" style={{ textAlign: "center", padding: 20 }}>Loading...</td>
              </tr>
            ) : tableData.length > 0 ? (
              tableData.map((item, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{item.appointment_date}</td>
                  <td>{item.capd_bag_no}</td>
                  <td>{item.capd_batch_expiry_date}</td>
                  <td>{item.no_of_bags}</td>
                  <td>{item.next_due_date}</td>

                  <td>
                    <Box sx={{ display: "flex", gap: 1 }}>
                      {!item.is_deleted && (index + 1 === tableData.length) && (
                        <Tooltip title="Edit Bag History" arrow>
                          <IconButton
                            size="small"
                            onClick={() => handleEdit(item)}
                            sx={{
                              backgroundColor: "#2c9faf",
                              color: "#fff",
                              borderRadius: "6px",
                              width: 36,
                              height: 36,
                              "&:hover": {
                                backgroundColor: "#238a98",
                              },
                            }}
                          >
                            <EditIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                      )}
                    </Box>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" style={{ textAlign: "center", padding: 20 }}>
                  {labels.noData}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {showEditModal && (
        <AddBagsModal
          isOpen={showEditModal}
          onClose={() => setShowEditModal(false)}
          patient={patient}
          bagData={selectedBag}
          onSuccess={handleEditSuccess}
        />
      )}
    </PMNDPModal>
  );
};

export default BagsHistoryModal;
